module.exports = __webpack_public_path__ + "img/pijltjes-header-mobiel.e1812e7889ac8e63c65d7ccf81ae1823.svg";